import React from 'react';

const AppointmentAdminTable = ({ data, openedit }) => {
  return (
    <table className="grid">
      <thead>
        <tr>
          <th style={{ width: '50px' }}></th>
          <th>Name</th>
          <th>Phone Number</th>
          <th>Date Time</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {data.map((a, i) => (
          <tr key={a._id || i}>
            <td>
              <select
                className="action-select"
                value=""
                onChange={(e) => e.target.value === "Edit" && openedit(a)}
              >
                <option value="" disabled>{i + 1}</option>
                <option value="Edit">Edit</option>
              </select>
            </td>
            <td>{a.name}</td>
            <td>{a.phonenumber}</td>
            <td>{a.datestr} | {a.time}</td>
            <td>
              <span className={"status-badge " + (a.status?.toLowerCase() || "pending")}>
                {a.status}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AppointmentAdminTable;
